/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {

  async fetchTotalLeaseSuppliesOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/leaseSuppliesOrder/getTotalLeaseSuppliesOrder`
      )
      payload.loading.close()
      commit('SET_TOTAL_LEASE_SUPPLIES_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },

  async fetchLeaseSuppliesOrder({ commit }, payload) {
    
    
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/leaseSuppliesOrder/getLeaseSuppliesOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_LEASE_SUPPLIES_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },


  async addNewLeaseSuppliesOrder({ commit }, payload) {
 
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/leaseSuppliesOrder/save`, payload.order)
      payload.order.idLeaseSuppliesOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_LEASE_SUPPLIES_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/suprimentos-locacao`).catch(() => { });
  },



  async removeLeaseSuppliesOrder({ commit }, payload) {
    let idLeaseSuppliesOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/leaseSuppliesOrder/remove`, { idLeaseSuppliesOrder })
      payload.loading.close()
      commit('REMOVE_LEASE_SUPPLIES_ORDER', idLeaseSuppliesOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updateLeaseSuppliesOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/leaseSuppliesOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_LEASE_SUPPLIES_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      //console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/suprimentos-locacao`).catch(err => { });
  },

  async trashLeaseSuppliesOrder({ commit }, payload) {
    let idLeaseSuppliesOrder = payload.idOrder
    
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/leaseSuppliesOrder/trash`,{ idLeaseSuppliesOrder }
      )
      payload.loading.close()
      commit('REMOVE_LEASE_SUPPLIES_ORDER', idLeaseSuppliesOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },
}
